import { createFileRoute } from '@tanstack/react-router'
import { LandingRedirectContent } from 'pages/redirects/LandingRedirectContent'
import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

const landingSearchParamsSchema = z.object({
  [SEARCH_PARAM_ORG_ID]: z.string().optional(),
  [SEARCH_PARAM_SITE_ID]: z.string().optional(),
})

export const Route = createFileRoute('/landing')({
  component: LandingRouteComponent,
  validateSearch: landingSearchParamsSchema,
  staticData: {
    title: 'Landing',
  },
})

function LandingRouteComponent() {
  const params = Route.useSearch()
  const orgId = params[SEARCH_PARAM_ORG_ID]
  const siteId = params[SEARCH_PARAM_SITE_ID]

  return <LandingRedirectContent orgId={orgId} siteId={siteId} />
}
